import { isNotNil } from "@mcwd/typescript-type-guards";
import type { FormWidgetData } from "../../../widgetDataTs.js";
import { GatingLevel, type GatingLevelFor } from "../../types/definitions/gating/gating-level.js";
import type { IFormSettings } from "../../form-settings/form-settings-factory.js";
import type { AnyFormSettingsKey } from "../../form-settings/form-experience/form-settings-keys.js";
import { getGatingLevelFromInitParameter } from "./get-gating-level-from-init-parameter-only.js";
import { getGatingLevelFromSelf } from "./get-gating-level-from-exp-settings-self-only.js";
import { getGatingLevelFromWidgetData } from "./get-gating-level-from-widget-data-only.js";
import type { FormOrFormExperienceType } from "./FormOrFormExperienceType.js";

export function getInitialGatingLevel<TFormOrExperience extends FormOrFormExperienceType>(
  type: TFormOrExperience,
  formSettingsKey: AnyFormSettingsKey,
  settings: IFormSettings,
  widgetData: FormWidgetData,
  gatingLevelCustom?: GatingLevel.FormExperience
): GatingLevelFor<TFormOrExperience> {
  const { gateLevelSource } = settings;

  if (gateLevelSource.length === 0) {
    throw new Error(`Invalid form experience settings for formSettingsKey '${formSettingsKey}'. gateLevelSource array has zero elements!`);
  }
  const initParamGatingLevel = getGatingLevelFromInitParameter(type, formSettingsKey, settings, gatingLevelCustom);
  if (isNotNil(initParamGatingLevel)) {
    return initParamGatingLevel;
  }
  const selfGatingLevel = getGatingLevelFromSelf(settings);
  if (gateLevelSource.length === 1 && isNotNil(selfGatingLevel)) {
    return selfGatingLevel as GatingLevelFor<TFormOrExperience>;
  }

  const widgetDataGatingLevel = getGatingLevelFromWidgetData(type, formSettingsKey, settings, widgetData);

  if (isNotNil(widgetDataGatingLevel)) {
    return widgetDataGatingLevel;
  }
  if (isNotNil(selfGatingLevel)) {
    return selfGatingLevel as GatingLevelFor<TFormOrExperience>;
  }
  throw new Error(`${type} could not be determined for form experience "${formSettingsKey}"`);
}